import { ClassAttributes, InputHTMLAttributes } from "react";
import { JSX } from "react/jsx-runtime";

function BaseCheckbox(props: JSX.IntrinsicAttributes & ClassAttributes<HTMLInputElement> & InputHTMLAttributes<HTMLInputElement>) {
    props = {className: "cursor-pointer", ...props, type: "checkbox"};
    return (
    <div className="cb-wrapper">
        <input {...props}/>
        <svg viewBox="0 0 16 12" width="0.8em">
            <use href="#uv-checkbox-mark"/>
        </svg>
    </div>
    )
}

export default BaseCheckbox;